import { createStore,  } from 'redux';
import ProductReducer from '../reducers/reducer'
const store =  createStore(ProductReducer);
export default store;